export default {
  state: {
    params:[], //用户权限标识集合
    unReadNotice:0 //用户未读消息数量
  },
  getters: {

  },
  mutations: {
      setPerms(state, perms){  // 用户权限标识集合
          state.perms = perms;
      },
      setUnReadNotice(state, unReadNotice){
        state.unReadNotice = Number(unReadNotice);
      }
  },
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js